export const isActualProduct = (productId: number): boolean =>
  !!productId && productId > 0;
